export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS

    $(window).scroll(function() {
      let scrollTop = $(window).scrollTop();
      $('.cover-home h1').css({
        'margin-top': scrollTop / 3.5,
        opacity: 1 - scrollTop / 400,
      });
    });

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js